export function loadMemberInfo() {
  return {
    type: 'LOAD_MEMBER_INFO',
  };
}

export function loadMemberInfoCompletion(error, data) {
  return {
    type: 'LOAD_MEMBER_INFO_COMPLETION',
    error,
    data,
  };
}

export function loadAgentInfo() {
  return {
    type: 'LOAD_AGENT_INFO',
  };
}

export function loadAgentInfoCompletion(error, data) {
  return {
    type: 'LOAD_AGENT_INFO_COMPLETION',
    data,
    error,
  };
}

export function syncAgentInfoInput(input, reset) {
  return {
    type: 'SYNC_AGENT_INFO_INPUT',
    input,
    reset,
  };
}

export function applyAgent() {
  return {
    type: 'APPLY_AGENT',
  };
}

export function applyAgentCompletion(error, data) {
  return {
    type: 'APPLY_AGENT_COMPLETION',
    data,
    error,
  };
}

export function upgradeToAgent() {
  return {
    type: 'UPGRADE_TO_AGENT',
  };
}

export function upgradeToAgentCompletion(error, data) {
  return {
    type: 'UPGRADE_TO_AGENT_COMPLETION',
    error,
    data,
  };
}

export function loadAgentInvoiceProxyRecord() {
  return {
    type: 'LOAD_AGENT_INVOICE_PROXY_RECORD',
  };
}
export function loadAgentInvoiceProxyRecordCompletion(error = null, data = {}) {
  return {
    type: 'LOAD_AGENT_INVOICE_PROXY_RECORD_COMPLETION',
    error,
    data,
  };
}
/* export function syncAgentInvoiceProxyInput(input, reset) {
  return {
    type: 'SYNC_AGENT_INVOICE_PROXY_INPUT',
    input,
    reset,
  };
}
export function saveAgentInvoiceProxy() {
  return {
    type: 'SAVE_AGENT_INVOICE_PROXY',
  };
}
export function saveAgentInvoiceProxyCompletion(error = null, data = {}) {
  return {
    type: 'SAVE_AGENT_INVOICE_PROXY_COMPLETION',
    error,
    data,
  };
} */

/* export function syncAgentIdCardInfoInput(input, reset) {
  return {
    type: 'SYNC_AGENT_IDCARD_INFO_INPUT',
    input,
    reset,
  };
}
export function saveAgentIdCardInfo() {
  return {
    type: 'SAVE_AGENT_IDCARD_INFO',
  };
}
export function saveAgentIdCardInfoCompletion(error = null, data = {}) {
  return {
    type: 'SAVE_AGENT_IDCARD_INFO_COMPLETION',
    error,
    data,
  };
} */

export function loadConsumeHistory() {
  return {
    type: 'LOAD_CONSUME_HISTORY',
  };
}
export function loadConsumeHistoryCompletion(error, data) {
  return {
    type: 'LOAD_CONSUME_HISTORY_COMPLETION',
    error,
    data,
  };
}

export function syncAgentESignInput(input, reset) {
  return {
    type: 'SYNC_AGENT_E_SIGN_INPUT',
    input,
    reset
  }
}

export function saveAgentESignEdit() {
  return {
    type: 'SAVE_AGENT_E_SIGN_EDIT'
  }
}

export function saveAgentESignEditCompletion(error) {
  return {
    type: 'SAVE_AGENT_E_SIGN_EDIT_COMPLETION',
    error,
  }
}
